<ng-container *transloco="let t">
  <app-page-template>
    <div class="container">
      <div class="pt-48-38 pb-300-228">
        <app-grey-card-with-title [title]="t('app.user.profile.settings')" [removeContentPaddingTop]="true">
          <ng-container [ngSwitch]="userProfileComponentState">
            <!--              TODO SUCCESS-->
            <div *ngSwitchCase="userProfileComponentStateType.SUCCESS">
              <div class="d-flex justify-content-center flex-column align-items-center">
                <h1 class="text-uppercase pb-4">{{ t('signup.your.adventure.can.start') }}</h1>
                <div class="rounded-circle d-inline-flex align-items-center justify-content-center">
                  <i class="bi bi-check2"></i>
                </div>
                <span class="success-text-wrapper pt-4">
                  {{ t('signup.email.sent.with.verification.link') }}
                </span>
              </div>
              <div class="pt-5">
                <app-button [label]="t('app.common.go.back')" [btnClass]="'btn-primary-red btn-large'"/>
              </div>
            </div>
            <div *ngSwitchDefault>
              <div class="text-center pt-40 pb-60">
                <div class="form-floating">
                  <div class="avatar-wrapper">
                    <div class="el-1">
                      <div>
                        <input type="file" accept="image/*" #file (change)="processFile(file)">
                        @if (profilePicture) {
                          <button class="avatar-button" (click)="file.click()">
                            <img [src]="profilePicture" class="avatar" alt="Avatar">
                          </button>
                        } @else {
                          <button class="avatar-button" (click)="file.click()">
                            <img src="assets/img/blank_profile.webp" class="avatar" alt="Avatar">
                          </button>
                        }
                      </div>
                    </div>
                    @if (profilePicture && editProfilePictureMode) {
                      <div class="el-2">
                        <button (click)="onDeleteProfilePicture()" class="btn shadow btn-circle red-btn">
                          <i class="bi bi-x-lg bold"></i>
                        </button>
                      </div>
                    }
                    @if (editProfilePictureMode) {
                      <div class="el-3">
                        <input type="file" accept="image/*" #file (change)="processFile(file)">
                        <button (click)="file.click()" class="btn shadow btn-circle black-btn">
                          <i class="bi bi-upload bi-bold"></i>
                        </button>
                      </div>
                    } @else {
                      <div class="el-3">
                        <button type="button" (click)="onEditProfilePicture()" class="btn shadow btn-circle red-btn">
                          <i class="bi bi-pencil-fill"></i>
                        </button>
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="px-10">
                <form #userProfileFormEdit="ngForm" [formGroup]="inputForm">
                  <div class="pb-28 fw-bold text-uppercase">
                    {{ t('app.user.profile.personal.information') }}
                  </div>
                  <div class="row">
                    <div class="col-12 col-xl-6">
                      <app-input formControlName="firstname" label="app.common.first.name"/>
                    </div>
                    <div class="col-12 col-xl-6">
                      <app-input formControlName="lastname" label="app.common.last.name"/>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-xl-6">
                      <div class="pt-20-10">
                        <app-select formControlName="gender" [items]="genders"
                                    [labelKey]="'id'" labelKeyPrefix="app.common.gender." label="app.common.gender"
                                    valueKey="id"/>
                      </div>
                    </div>
                    <div class="col-12 col-xl-6">
                      <div class="pt-20-10">
                        <div class="form-floating mb-3">
                          <app-date-time-input formControlName="birthDay" [displayTime]="false"
                                               [minDate]="getMinDateForBirthday()" [maxDate]="currentDate"
                                               [label]="t('app.common.birthDay') | titlecase"/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-xl-6">
                      <div class="pt-20-10">
                        <app-input formControlName="email" label="app.common.email"/>
                      </div>
                    </div>
                    <div class="col-12 col-xl-6">
                      <div class="pt-20-10">
                        <app-tel-input [formControlName]="'phoneNumber'"
                                       [label]="t('app.common.phoneNumber')"
                                       [numberPlaceholder]="t('app.common.phoneNumber')"></app-tel-input>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-xl-6">
                      <div class="pt-20-10">
                        <app-input formControlName="address" label="app.common.address"/>
                      </div>
                    </div>
                    <div class="col-12 col-xl-6">
                      <div class="pt-20-10">
                        <app-input formControlName="city" label="app.common.placeOfResidence"/>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-xl-6">
                      <div class="pt-20-10">
                        <app-input formControlName="zip" label="app.common.zip"/>
                      </div>
                    </div>
                    <div class="col-12 col-xl-6">
                      <div class="pt-20-10">
                        <app-select formControlName="country"
                                    [hasDefault]="true" [items]="countries" valueKey="id" labelKey="name"
                                    label="app.common.country"/>
                      </div>
                    </div>
                  </div>

                  <div class="pb-28 pt-48-38 fw-bold text-uppercase">
                    {{ t('app.user.profile.other.information') }}
                  </div>
                  <div class="row">
                    <div class="col-12 col-xl-6">
                      <div class="pt-20-10">
                        <app-input formControlName="club" label="app.common.club"/>
                      </div>
                    </div>
                    <div class="col-12 col-xl-6">
                      <div class="pt-20-10">
                        <app-tel-input [formControlName]="'emergencyPhone'"
                                       [label]="t('app.common.emergencyPhone')"
                                       [numberPlaceholder]="t('app.common.emergencyPhone')"></app-tel-input>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="pt-20-10">
                        <app-input formControlName="identityCardNumber"
                                   label="app.common.identityCardNumber"/>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-xl-6">
                      <div class="pt-20-10">
                        <div class="form-floating mb-3">
                          <app-date-time-input formControlName="identityCardExpires" [displayTime]="false"
                                               [minDate]="getMinDateForExpireCard()"
                                               [label]="t('app.common.identityCardExpires') | titlecase"/>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-xl-6">
                      <div class="pt-20-10">
                        <app-input formControlName="identityCardIssuer"
                                   label="app.common.identityCardIssuer"/>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-xl-6">
                      <div class="pt-20-10">
                        <app-select formControlName="tshirtSize"
                                    [hasDefault]="true" [items]="tshirtSizes" labelKey="name" valueKey="id"
                                    label="app.common.tshirtSize"/>
                      </div>
                    </div>
                    <div class="col-12 col-xl-6">
                      <div class="pt-20-10">
                        <app-select formControlName="meal" [hasDefault]="true"
                                    [items]="meals" labelKey="name" valueKey="id" label="app.common.meal"/>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="pt-20-10">
                        <app-input formControlName="nickname"
                                   label="app.common.nickname"/>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="pt-48-38 pb-42-32">
                        <div class="d-flex justify-content-center">
                          <app-rounded-button [label]="t('app.user.profile.update')" (onClick)="onUpdateProfile()"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="text-center" (click)="toProfilePage()">
                        <span class="link-button text-uppercase fw-semibold">{{
                            t('app.common.go.to.dashboard')
                          }}</span>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </ng-container>
        </app-grey-card-with-title>
      </div>
    </div>
  </app-page-template>
</ng-container>
